import React, { Fragment, useReducer } from "react";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./components";
import { LayoutContext, layoutState, layoutReducer } from "./components/shop";
import { CartProvider } from "./contexts/CartContext";

function App() {
  const [data, dispatch] = useReducer(layoutReducer, layoutState);
  return (
    <Fragment>
      <HelmetProvider>
        <CartProvider>
          <LayoutContext.Provider value={{ data, dispatch }}>
            <Routes />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </LayoutContext.Provider>
        </CartProvider>
      </HelmetProvider>
    </Fragment>
  );
}

export default App;
